var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFF1F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8334 30.33C34.6234 30.33 35.4634 30.41 36.3334 30.57V32.07C35.7134 31.91 34.8734 31.83 33.8334 31.83C31.9334 31.83 30.4434 32.16 29.3334 32.82V31.13C30.5034 30.6 32.0034 30.33 33.8334 30.33ZM29.3334 28.46C30.6234 27.93 32.1234 27.67 33.8334 27.67C34.6234 27.67 35.4634 27.74 36.3334 27.9V29.4C35.7134 29.24 34.8734 29.16 33.8334 29.16C31.9334 29.16 30.4434 29.5 29.3334 30.15V28.46ZM33.8334 26.5C31.9334 26.5 30.4434 26.82 29.3334 27.5V25.84C30.5634 25.28 32.0634 25 33.8334 25C34.6234 25 35.4634 25.08 36.3334 25.23V26.78C35.5934 26.59 34.7434 26.5 33.8334 26.5ZM37.3334 34.5V23C36.2934 22.67 35.1234 22.5 33.8334 22.5C31.7834 22.5 29.9534 23 28.3334 24V35.5C29.9534 34.5 31.7834 34 33.8334 34C35.0234 34 36.1934 34.16 37.3334 34.5ZM33.8334 20.5C36.1834 20.5 38.0234 21 39.3334 22V36.56C39.3334 36.68 39.2834 36.8 39.1734 36.91C39.0634 37 38.9434 37.08 38.8334 37.08C38.7234 37.08 38.6434 37.06 38.5834 37.03C37.3034 36.34 35.7134 36 33.8334 36C31.7834 36 29.9534 36.5 28.3334 37.5C26.9934 36.5 25.1634 36 22.8334 36C21.1734 36 19.5834 36.36 18.0834 37.07C18.0534 37.08 18.0134 37.08 17.9634 37.1C17.9234 37.11 17.8834 37.12 17.8334 37.12C17.7234 37.12 17.6034 37.08 17.4934 37C17.4438 36.9561 17.4039 36.9022 17.3763 36.8419C17.3488 36.7817 17.3341 36.7163 17.3334 36.65V22C18.6734 21 20.5134 20.5 22.8334 20.5C25.1634 20.5 26.9934 21 28.3334 22C29.6734 21 31.5034 20.5 33.8334 20.5Z",
    fill: "#FE544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIcon);
export default __webpack_public_path__ + "static/media/book-icon.86a0a5dd42a65335271ba228b5e736e8.svg";
export { ForwardRef as ReactComponent };